import $ from 'jquery';

const portalId = '6793681';
const formGuid = '12237cf4-c69a-46f7-87e9-ac84b81f0e03';
const hubspotSubmitEndpoint = `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formGuid}`;

export default function popupSection() {
	if (location.search === '?invalidatePopup') {
		localStorage.removeItem('openedPopup')
	}

	const $popupModal = $('#hubspot-form-modal');
	const openedPopup = localStorage.getItem('openedPopup');
	if ($popupModal.hasClass('should-open') && !openedPopup) {
		localStorage.setItem('openedPopup', true);
		$popupModal.data('toggler').open();
	}

	if ($popupModal.hasClass('should-open')) {
		$('.heading_button').click(() => {
			$popupModal.data('toggler').open();
		});
	}

	const $form = $popupModal.find('.form');

	const $firstNameField = $form.find('.first-name-field input');
	const $lastNameField = $form.find('.last-name-field input');
	const $companyNameField = $form.find('.company-name-field input');
	const $emailField = $form.find('.email-field input');
	const $submitButton = $form.find('button');

	const validateEmail = (email) => /\S+@\S+\.\S+/.test(email);
	$emailField.on('click', () => $emailField.css({ 'background-color': 'white' }));
	$firstNameField.on('click', () => $firstNameField.css({ 'background-color': 'white' }));

	$submitButton.click((ev) => {
		ev.preventDefault();
		let validated = true;

		// Check if all fields are valid, and add some UI notification to the invalid ones
		if (!validateEmail($emailField.val())) {
			$emailField.css({ 'background-color': '#ff4132' });
			validated = false;
		}

		if ($firstNameField.val().length === 0) {
			$firstNameField.css({ 'background-color': '#ff4132' });
			validated = false;
		}

		if (!validated) {
			return;
		}

		const callbackName = $form.attr('sw-recaptcha');
		if (callbackName && window[callbackName]) {
			window[callbackName];
		} else {
			$form.submit();
		}
	});

	$form.on('submit', async (ev) => {
		ev.preventDefault();

		// Check the recaptcha response
		const currentFormData = $form.serializeArray();
		const grecaptchaResponse = currentFormData.filter(d => d.name === 'g-recaptcha-response')[0].value;
		const formData = new FormData();
		formData.append('g-recaptcha-response', grecaptchaResponse);
		formData.append(csrfTokenName, csrfTokenValue);
		const grecaptchaCheckResponse = await fetch('/actions/hubspotform/default/recaptcha', {
			method: 'POST',
			headers: {
				'Accept': 'application/json'
			},
			body: formData
		});
		const grecaptchaCheck = await grecaptchaCheckResponse.json();

		if (!grecaptchaCheck.success) {
			throw new Error('Recaptcha failed');
		}

		const xhr = new XMLHttpRequest();
		const data = {
			fields: [
				{
					name: 'firstname',
					value: $firstNameField.val()
				},
				{
					name: 'lastname',
					value: $lastNameField.val()
				},
				{
					name: 'company',
					value: $companyNameField.val()
				},
				{
					name: 'email',
					value: $emailField.val()
				}
			]
		};

		const body = JSON.stringify(data);

		xhr.open('POST', hubspotSubmitEndpoint);
		xhr.setRequestHeader('Content-Type', 'application/json');

		xhr.onreadystatechange = () => {
			if(xhr.readyState == 4 && xhr.status == 200) { 
				$popupModal.find('.modal_content').html(`
					<div class="text">
						${JSON.parse(xhr.responseText).inlineMessage}
					</div>
				`);
			}
		};

		xhr.send(body);
	});
}



// WEBPACK FOOTER //
// ./source/scripts/sections/popup.js